export { default } from './LoanTabLayout';
